import axios from "axios";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { registerRoute } from "../../../utils/APIRoutes";

const Index = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (localStorage.getItem("chat-app-current-user")) {
      navigate("/");
    }
  }, []);

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleValidation = () => {
    const { password, confirmPassword, username, email } = values;
    if (password !== confirmPassword) {
      window.alert("Password and confirm password don't match");
      return false;
    } else if (username.length < 3) {
      window.alert("Username should be greater than 3 characters");
      return false;
    } else if (password.length < 8) {
      window.alert("Password should be greater than 8 characters");
      return false;
    } else if (email === "") {
      window.alert("Email is required");
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (handleValidation()) {
      const { email, username, password } = values;
      console.log("Next run axios");
      const { data } = await axios.post(registerRoute, {
        username,
        email,
        password,
      });
      if (data.status === false) {
        window.alert(data.msg);
      }
      if (data.status === true) {
        localStorage.setItem(
          "chat-app-current-user",
          JSON.stringify(data.user)
        );
        navigate("/");
      }
    }
  };

  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="row  Average-chart mt-4 mb-5">
            <div className="col-md-12">
              <div className="headerpage">
                <h2>Sign Up</h2>
                <img class="logoimg11" src="img/paygold-logo.png" alt="" />
              </div>
              <div className="FormBOx">
                <form action="" onSubmit={(event) => handleSubmit(event)}>
                  <div>
                    <label>Username:</label>
                    <input
                      type="text"
                      placeholder="Username"
                      name="username"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div>
                    <label>Email:</label>
                    <input
                      type="email"
                      placeholder="email"
                      name="email"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div>
                    <label>Password:</label>
                    <input
                      type="password"
                      placeholder="password"
                      name="password"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div>
                    <label>Confirm Password:</label>
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      name="confirmPassword"
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="btnsubmit text-center">
                    <button >Sign Up</button>
                    <p>
                      Already have an account?{" "}
                      <Link to="/login">Login now</Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Index;
